import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Statistics = () => {
  const AccordionStyle = {
    '&:before': {
      backgroundColor: 'transparent !important',
    },
  };
  return (
    <Accordion elevation={0} className="rounded-lg mb-4" sx={AccordionStyle}>
      <AccordionSummary
        sx={{ border: 'none' }}
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
      ><h2 className="text-xl font-bold text-black text-left">Statistics</h2>
      </AccordionSummary>
      <AccordionDetails>
        <div className="flex gap-4 w-full">
          <div className="flex-1 flex p-2 pl-5 flex-col items-start justify-center border rounded-lg bg-white">
            <p className="text-gray-800 ">Total Movies</p>
            <span className="font-semibold text-black text-lg mt-5 text-left">4</span>
          </div>
          <div className="flex-1 flex p-2 pl-5 flex-col items-start justify-center border rounded-lg bg-white">
            <p className="text-gray-800 ">Total Views</p>
            <span className="font-semibold text-black text-lg mt-5 text-left">0</span>
          </div>
          <div className="flex-1 flex p-2 pl-5 flex-col items-start justify-center border rounded-lg bg-white">
            <p className="text-gray-800 ">Total Earning</p>
            <span className="font-semibold text-black text-lg mt-5 text-left">₦ 0.00</span>
          </div>
        </div>
      </AccordionDetails>
    </Accordion>
  )
}

export default Statistics;